import { defineStore } from 'pinia'
import { getParams } from '@/utils'
import { useStorage } from '@vueuse/core'
import { reactive } from 'vue'

function isH5Page() {
  return location.hash.indexOf('#/h5/') === 0
}

export const useCacheStore = defineStore('cache', () => {
  const lc = reactive(
    useStorage('cache', {
      redirectUrl: '',
      clientId: '',
      loginOption: '',
      aliUid: '', //阿里云用户ID
      instanceId: '' // 实例ID，用于阿里云免登
    }).value
  )

  function goBackHome() {
    window.location.replace(lc.redirectUrl)
  }

  if (getParams('clientId')) {
    lc['clientId'] = getParams('clientId')
  } else {
    lc['clientId'] = !isH5Page() ? 'saas' : 'saas-h5'
  }
  if (getParams('loginOption')) {
    lc['loginOption'] = getParams('loginOption')
  }
  if (getParams('redirectUrl')) {
    lc['redirectUrl'] = getParams('redirectUrl')
  }
  if (getParams('aliUid')) {
    lc['aliUid'] = getParams('aliUid')
  }
  if (getParams('instanceId')) {
    lc['instanceId'] = getParams('instanceId')
  }

  return {
    redirectUrl: lc.redirectUrl,
    homeUrl: lc.redirectUrl,
    clientId: lc.clientId,
    loginOption: lc.loginOption,
    aliUid: lc.aliUid,
    instanceId: lc.instanceId,
    goBackHome
  }
})
